var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 51.1333C21.752 51.1327 20.1321 50.706 18.6975 49.8949L4.8308 42.0498C3.36649 41.2203 2.14808 40.0176 1.29953 38.5643C0.450984 37.1109 0.00259789 35.4587 0 33.7757V18.2251C0.00233066 16.5421 0.450604 14.8898 1.29918 13.4364C2.14775 11.983 3.36632 10.7804 4.8308 9.95107L18.6975 2.10513C20.1321 1.29334 21.7525 0.866699 23.4009 0.866699C25.0493 0.866699 26.6696 1.29334 28.1043 2.10513L41.9709 9.95107C43.4351 10.7806 44.6533 11.9833 45.5016 13.4367C46.3498 14.8901 46.7978 16.5423 46.8 18.2251V33.7757C46.7968 35.4584 46.3482 37.1103 45.4999 38.5636C44.6516 40.0168 43.4337 41.2196 41.9701 42.0498L28.1034 49.8949C26.6686 50.7062 25.0483 51.1328 23.4 51.1333Z",
    fill: "url(#paint0_linear_9_480)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1333 18.2251V33.7749C42.1334 34.6918 41.8897 35.5923 41.4274 36.3841C40.9651 37.176 40.3007 37.8308 39.5021 38.2815L25.6355 46.1275C24.8518 46.5705 23.9669 46.8034 23.0667 46.8034C22.1664 46.8034 21.2815 46.5705 20.4979 46.1275L6.6312 38.2815C5.83268 37.8308 5.16825 37.176 4.70592 36.3841C4.2436 35.5923 3.99998 34.6918 4 33.7749V18.2251C4.00048 17.3089 4.24435 16.4092 4.70666 15.6181C5.16897 14.827 5.83314 14.1729 6.6312 13.7228L20.4979 5.87599C21.2815 5.4329 22.1664 5.20004 23.0667 5.20004C23.9669 5.20004 24.8518 5.4329 25.6355 5.87599L39.5021 13.7228C40.3002 14.1729 40.9644 14.827 41.4267 15.6181C41.889 16.4092 42.1329 17.3089 42.1333 18.2251Z",
    fill: "url(#paint1_linear_9_480)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0425 27.5586V20H20.3626V31H19.2328L15.3201 23.0014V31H14V20H15.3201V20.0157L15.332 20L19.0425 27.5586Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5299 20V21.65H22.9858V24.7457H26.3872V26.3957H22.9858V31H21.6657V20H26.5299Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20V21.65H30.6214V31H29.3013V21.65H26.9347V20H33Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_480",
    x1: 7.48951e-9,
    y1: 12.5276,
    x2: 46.7427,
    y2: 13.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F56FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_480",
    x1: 4,
    y1: 14.8513,
    x2: 42.0876,
    y2: 15.9383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F56FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#8085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7AA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSold);
export default __webpack_public_path__ + "static/media/sold.6e7307ddcbac41f589fc6404ae34d6a9.svg";
export { ForwardRef as ReactComponent };